module.exports = __webpack_public_path__ + "img/Plan3-1.abf3dcf0.jpg";